import React, { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import closeIcon from "../../assets/images/close.svg";
import annualsummary from "../../assets/images/My_machine.svg";
import PlusPlaceholder from "../../assets/images/PlusImage.png";
import searchicon from "../../assets/images/searchicon.svg";
import Nodata from "./Nodata";
function CustomLogoUploadPopup({
  handleshowPopup,
  item,
  input,
  setinput,
  loader,
  data,
  file1,
  setfile,
  multiselectvalidation,
  setmultiselectvalidation,
}) {
  const [SearchTerm, setSearchTerm] = useState("");
  const MachineLogoref = useRef();
  const [FilteredIcons, setFilteredIcons] = useState([]);
  const [file, setFile] = useState(file1);
  const MachineLogoFileChange = async (e) => {
    const file2 = e.target.files[0];
    if (!file2) return;
    if (file2.size > 50 * 1024) {
      return toast.error("File size must be less than or equal to 50KB.");
    }
    if (file2.type !== "image/png" && file2.type !== "image/jpeg") {
      return toast.error("Only PNG and JPEG images are allowed.");
    }
    const img = new Image();
    img.src = URL.createObjectURL(file2);
    img.onload = () => {
      if (img.width !== 100 || img.height !== 100) {
        return toast.error("Image dimensions must be exactly 100x100 pixels.");
      }
      let updatedValidation = { ...multiselectvalidation };
      updatedValidation.machinelogo = false;
      setmultiselectvalidation(updatedValidation);
      setinput({
        ...input,
        machinelogo: file2,
        machinelogourl: "",
        errors: {
          ...input.errors,
          machinelogo: "",
        },
      });
      setFile(URL.createObjectURL(file2));
      // setfile(URL.createObjectURL(file2));
      setfile(file2);
      handleshowPopup();
    };

    img.onerror = () => {
      toast.error("Invalid image file.");
    };
  };
  useEffect(() => {
    if (data?.length > 0) {
      let temp = data?.filter((f) => f.tag.includes(SearchTerm));
      setFilteredIcons(temp);
    }
  }, [SearchTerm]);
  // const fnSelectIcon = (item) => {
  //   if (item) {
  //     let updatedValidation = { ...multiselectvalidation };
  //     updatedValidation.machinelogo = false;
  //     setmultiselectvalidation(updatedValidation);
  //     setinput({
  //       ...input,
  //       machinelogourl: item?.filename,
  //       machinelogo: "",
  //       errors: {
  //         ...input.errors,
  //         machinelogourl: "",
  //       },
  //     });
  //     setfile(item?.filename);
  //     handleshowPopup();
  //   }
  // };

  const fnSelectIcon = (item) => {
    if (item) {
      const updatedValidation = { ...multiselectvalidation };
      updatedValidation.machinelogo = false;
      setmultiselectvalidation(updatedValidation);
      setinput((prevInput) => ({
        ...prevInput,
        machinelogourl: item?.filename,
        machinelogo: "",
        errors: {
          ...prevInput.errors,
          machinelogourl: "",
        },
      }));
  
      setfile(item?.filename);
      handleshowPopup();
    }
  };
  
  return (
    <div className="schedular-popup sort-and-filter-popup CustomLogoUploadPopup-main">
      <div className="popup-title">
        <div>
          <span>
            Machine Icon{" "}
            {/* <span className="red-color-text">(100x100 pixels only)</span> */}
          </span>
          {/* <span className="red-color-text">(100 X 100 Pixels) upto 50kb</span> */}
          <span class="mt-0 addmachineicon-error">
            (100 X 100 Pixels - upto 50 KB)
          </span>
        </div>
        <img
          className="cursor-pointer"
          onClick={() => handleshowPopup()}
          src={closeIcon}
        />
      </div>
      <input
        type="file"
        className="form-control d-none"
        id="profileImg11"
        ref={MachineLogoref}
        accept="image/png, image/jpeg"
        onChange={MachineLogoFileChange}
      />
      <label className="file-input__label mt-2 ms-2" htmlFor="profileImg11">
        {file !== undefined ? (
          <img
            height={38}
            src={file ? file : PlusPlaceholder}
            className="custom-selected-icon"
            // onError={({ currentTarget }) => {
            //   currentTarget.onerror = null;
            //   currentTarget.src = annualsummary;
            // }}
          />
        ) : (
          <img
            height={38}
            src={PlusPlaceholder}
            className="custom-selected-icon"
            alt={input.machinelogo ? file : PlusPlaceholder}
          />
        )}
      </label>
      <div className="popup-body">
        <InputGroup>
          <InputGroup.Text id="basic-addon1">
            <img src={searchicon} alt="searchicon" className="cursor-pointer" />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search"
            aria-label="Search"
            aria-describedby="basic-addon1"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
        <div>
          {loader ? (
            "Loading..."
          ) : FilteredIcons?.length > 0 ? (
            <>
              <div className="all-logo-icons">
                {FilteredIcons?.map((item, index) => (
                  <div
                    key={index}
                    onClick={(e) => fnSelectIcon(item)}
                    className="single-logo-icons"
                  >
                    <img
                      src={item?.filename}
                      alt="searchicon"
                      className="cursor-pointer"
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Nodata />
          )}
        </div>
      </div>

      <div className="popup-footer">
        <button
          className="blue-btn"
          id="sort-filter"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        >
          Cancel
        </button>
        {/* <button className="blue-btn">Apply</button> */}
      </div>
    </div>
  );
}

export default CustomLogoUploadPopup;
